import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/LAD'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("lad")

    const LAD = () => import(/* webpackChunkName: "LAD-page" */ 'containers/Pages/LAD/LAD')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(LAD)
    })
  }
}
